"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFakeFutureAPI = exports.createFutureAPI = exports.FutureAPIImp = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TransRequestSymbol = (base, quote) => {
    return `${base}/${quote}`;
};
class FutureAPIImp {
    constructor(apiKey) {
        this.symbols = null;
        this.symbolMap = new Map();
        this.apiKey = apiKey;
    }
    getPublicHost() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    }
    setExchangeSymbols(symbols) {
        this.symbols = symbols;
        for (const symbol of symbols) {
            this.symbolMap.set(`${symbol.base}_${symbol.quote}`, symbol);
        }
    }
    getInnerApiKeyInfo() {
        return this.apiKey;
    }
    /**
     * 请求币安合约交易配置文件
     */
    requestLeverageConfigures() {
        const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().CONFIG_HOST;
        if (!host) {
            return (0, rxjs_1.of)(0).pipe((0, operators_1.map)(() => {
                throw "can not fetch CONFIG_HOST";
            }));
        }
        const url = `${host}/leverage_configs.json`;
        return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, { "Cache-Control": "max-age=0" }, (res) => {
            return res;
        }).pipe((0, operators_1.map)((res) => {
            return res[ExchangeID_1.ExchangeID.BINANCE];
        }));
    }
    // 获取交易对列表
    getExchangeSymbols() {
        let url;
        if (this.apiKey.market === ExchangeID_1.ExchangeID.PIONEXV2) {
            url = `${this.getPublicHost()}/swap_markets`;
        }
        else {
            url = `${this.getPublicHost()}/${this.apiKey.market}/swap/public/markets/`;
        }
        return trade_utils_lib_1.ObservableUtils.get(url, null, null).pipe((0, operators_1.map)((data) => {
            const list = data.filter((item) => {
                // if ("active" in item) {
                //     return item["active"];
                // }
                return true;
            });
            const mappedSymbols = list.map((symbol) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                const exchangeSymbol = {
                    symbol: symbol.symbol,
                    base: symbol.base,
                    quote: symbol.quote,
                    baseDisplay: symbol.base,
                    isLeverage: false,
                    isSpot: false,
                    quoteDisplay: symbol.quote,
                    symbolType: symbol.base.endsWith(".CMSWAP") ? trade_utils_lib_1.ExchangeSymbolType.cm_swap_binance : trade_utils_lib_1.ExchangeSymbolType.swap_binance,
                };
                exchangeSymbol.baseDisplay = symbol.base.substr(0, symbol.base.length - 5);
                if (symbol.limits) {
                    exchangeSymbol.limit = {
                        amount: {
                            max: ((_a = symbol.limits.amount) === null || _a === void 0 ? void 0 : _a.max) ? parseFloat(symbol.limits.amount.max) : null,
                            min: ((_b = symbol.limits.amount) === null || _b === void 0 ? void 0 : _b.min) ? parseFloat(symbol.limits.amount.min) : null,
                        },
                        price: {
                            max: ((_c = symbol.limits.price) === null || _c === void 0 ? void 0 : _c.max) ? parseFloat(symbol.limits.price.max) : null,
                            min: ((_d = symbol.limits.price) === null || _d === void 0 ? void 0 : _d.min) ? parseFloat(symbol.limits.price.min) : null,
                        },
                        cost: {
                            max: ((_e = symbol.limits.cost) === null || _e === void 0 ? void 0 : _e.max) ? parseFloat(symbol.limits.cost.max) : null,
                            min: ((_f = symbol.limits.cost) === null || _f === void 0 ? void 0 : _f.min) ? parseFloat(symbol.limits.cost.min) : null,
                        },
                        spending: {
                            max: ((_g = symbol.limits.spending) === null || _g === void 0 ? void 0 : _g.max) ? parseFloat(symbol.limits.spending.max) : null,
                            min: ((_h = symbol.limits.spending) === null || _h === void 0 ? void 0 : _h.min) ? parseFloat(symbol.limits.spending.min) : null,
                        },
                        dumping: {
                            max: ((_j = symbol.limits.dumping) === null || _j === void 0 ? void 0 : _j.max) ? parseFloat(symbol.limits.dumping.max) : null,
                            min: ((_k = symbol.limits.dumping) === null || _k === void 0 ? void 0 : _k.min) ? parseFloat(symbol.limits.dumping.min) : null,
                        },
                    };
                }
                ///> 这个确保精度数据不为负数，不然客户端格式化的时候可能会崩溃
                exchangeSymbol.precision = Math.abs(parseInt((_m = (_l = symbol.precision) === null || _l === void 0 ? void 0 : _l.price) !== null && _m !== void 0 ? _m : 8));
                exchangeSymbol.amount = Math.abs(parseInt((_p = (_o = symbol.precision) === null || _o === void 0 ? void 0 : _o.amount) !== null && _p !== void 0 ? _p : 8));
                exchangeSymbol.precisionCost = ((_q = symbol.precision) === null || _q === void 0 ? void 0 : _q.cost) ? Math.abs(parseInt(symbol.precision.cost)) : undefined;
                this.symbolMap.set(`${exchangeSymbol.base}_${exchangeSymbol.quote}`, exchangeSymbol);
                return exchangeSymbol;
            });
            this.symbols = mappedSymbols;
            return mappedSymbols;
        }));
    }
    getSymbol(base, quote) {
        const key = `${base}_${quote}`;
        if (this.symbolMap.has(key)) {
            return this.symbolMap.get(key);
        }
        return undefined;
    }
    getLastFundingRate(base, quote) {
        let url;
        if (this.apiKey.market === ExchangeID_1.ExchangeID.PIONEXV2) {
            url = `${this.getPublicHost()}/swap_last_funding_rate/`;
        }
        else {
            url = `${this.getPublicHost()}/${this.apiKey.market}/swap/public/last_funding_rate/`;
        }
        const symbol = TransRequestSymbol(base, quote);
        return trade_utils_lib_1.ObservableUtils.get(url, { symbol: symbol }, null, null);
    }
}
exports.FutureAPIImp = FutureAPIImp;
function createFutureAPI(apiKey) {
    return new FutureAPIImp({
        key: apiKey.key_id,
        secret: "",
        extra: "",
        market: apiKey.exchange,
        cloudKeyId: apiKey.key_id,
    });
}
exports.createFutureAPI = createFutureAPI;
function createFakeFutureAPI(market) {
    let apiKey = {
        key: "fake",
        secret: "fake",
        extra: "",
        market: market,
        cloudKeyId: "",
    };
    return new FutureAPIImp(apiKey);
}
exports.createFakeFutureAPI = createFakeFutureAPI;
